export const DEFAULT_CURRENCY = 'ETH'

export const BIGNUMBER_FMT = {
  prefix: '',
  decimalSeparator: '.',
  groupSeparator: ',',
  groupSize: 3
}

// mint token
export const MINTTOKEN = Object.freeze({
  ALLNEW: 'ALLNEW',
  ENDED: 'ENDED',
  OTHERS: 'OTHERS',
  BAKE: 'BAKE',
  BAKEV2: 'BAKEV2',
  PET: 'PET',
  BPET: 'BPET',
  WEAPON: 'WEAPON',
  BEST: 'BEST',
  WEAPONNFT: 'WEAPONNFT',
  PETNFT: 'PETNFT',
  HELMETNFT: 'HELMETNFT',
  ALLNFT: 'ALLNFT',
  HATNFT: 'HATNFT',
  ETH2MASTER: 'ETH2MASTER',
  AETHANDETH2: 'AETHANDETH2',
  AETHMASTER: 'AETHMASTER',
  TEN: 'TEN',
  TENNFT: 'TENNFT',
  WSOTE: 'WSOTE',
  SHIELD: 'SHIELD',
  BRY: 'BRY',
  BAKESTAKING: 'BAKESTAKING',
  DEFI100: 'DEFI100',
  DEFI100OLD: 'DEFI100OLD',
  BANANA: 'BANANA',
  PCWS: 'PCWS',
  SEASCAPENFT: 'SEASCAPENFT',
  WAR: 'WAR',
  TKONFT: 'TKONFT',
  WAR2: 'WAR2',
  DIESEL: 'DIESEL',
  MX: 'MX',
  ALICE: 'ALICE',
  ALICENFT: 'ALICENFT',
  DFY: 'DFY',
  GFX: 'GFX',
  XDITTO: 'XDITTO',
  SACT: 'SACT',
  PET3: 'PET3',
  HYFI: 'HYFI',
  TCT: 'TCT',
  TKO: 'TKO',
  TKONFTSTAKE: 'TKONFTSTAKE',
  NFTSTAKE: 'NFTSTAKE',
  ONEINCHBAKENFT: 'ONEINCHBAKENFT',
  TKO2: 'TKO2',
  TSA: 'TSA',
  TLM: 'TLM',
  XDITTONFT: 'XDITTONFT',
  POKER: 'POKER',
  TLM2: 'TLM2',
  TLM3: 'TLM3',
  TLM4: 'TLM4',
  BONDLY: 'BONDLY',
  BONDLY2: 'BONDLY2',
  GINU: 'GINU',
  BONDLYNFT: 'BONDLYNFT',
  TOYNFTSTAKE: 'TOYNFTSTAKE',
  LEV: 'LEV',
  TLM5: 'TLM5',
  WSG: 'WSG',
  TOYNFT: 'TOYNFT',
  BETHMASTER: 'BETHMASTER',
  TOKAU: 'TOKAU',
  BMMNFTSTAKE: 'BMMNFTSTAKE',
  BNRG: 'BNRG',
  BMONCNFTSTAKE: 'BMONCNFTSTAKE',
  DOGO: 'DOGO',
  EGG: 'EGG',
  KALATA: 'KALATA',
  DON: 'DON',
  NT: 'NT',
  MONI: 'MONI',
  KXA: 'KXA',
  NBL: 'NBL'
})
